// https://github.com/axios/axios (Promise based HTTP client for the browser and node.js)
import axios from 'axios';
import eventBus from 'pubsub-js';
import qs from 'qs';
import RequestLoadingAnimationService from '@/shared/services/RequestLoadingAnimationService';
import config from '../config';
import { RequestError, NoConnectionError } from './errors';
import AuthService from './services/AuthService';

const instance = axios.create({
  // paramsSerializer: {
  //   indexes: null
  // },
  baseURL: config.appUrls.api,
  timeout: 50000,
});

instance.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' });

let xhrCreations = 0;
let xhrResolutions = 0;

function isLoading() {
  return xhrResolutions < xhrCreations;
}
function updateStatus() {
  if (isLoading()) RequestLoadingAnimationService.showSmallLoadingAnimation();
  else RequestLoadingAnimationService.hideSmallLoadingAnimation();
}

instance.interceptors.response.use(
  successRes => {
    xhrResolutions++;
    updateStatus();
    return successRes;
  },
  error => {
    xhrResolutions++;
    updateStatus();
    return Promise.reject(error);
  },
);
// Add a request log interceptor
instance.interceptors.request.use(requestConfig => {
  xhrCreations++;
  updateStatus();
  const token = AuthService.getToken();
  // this is required in order to make arrays work in querystrings on our backend API to transform
  // ownCompanies[]=1&ownCompanies[]=2 into ownCompanies=1&ownCompanies=2
  //requestConfig.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' });
  requestConfig.headers.Authorization = `Bearer ${token}`;
  return requestConfig;
});

// Add error transform interceptor
instance.interceptors.response.use(
  response => response,
  error => {
    // Don't log cancelled requests
    if (axios.isCancel(error)) return Promise.reject(error);

    if (
      error.config &&
      Object.prototype.hasOwnProperty.call(error.config, 'handleError') &&
      error.config.handleError === true
    ) {
      // the error will be handled locally
      return Promise.reject(error);
    }

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      eventBus.publish('error', new RequestError(error.response, error.config.url));
    } else if (error.request) {
      // The request was made but no response was received
      // Typically there is a network error or no internet connection
      // console.log(error.request);
      eventBus.publish('error', new NoConnectionError());
    } else {
      // Something happened in setting up the request that triggered an Error
      eventBus.publish('error', error);
    }

    return Promise.reject(error);
  },
);

export default {
  base: instance,
};
